/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React from 'react';
import SectionData from 'components/machine/sectionData';
import { AnalogItem } from '@umati/dashboard-types';
import Gauge, { ShowedValue } from '../common/Gauge';
import './SurfaceProcess.scss';
import { labels } from '@umati/dashboard-common';
import { SurfaceParameterTypeList } from './SurfaceTypes';
import SurfaceParameterTypes from './SurfaceParameterTypes';

export interface ISurfaceProcess {
  ActualValue?: AnalogItem;
  SetPointValue?: AnalogItem;
  '<Process>'?: SurfaceParameterTypeList;
  MaterialA?: SurfaceParameterTypeList;
  MaterialB?: SurfaceParameterTypeList;
  // Recipe?: ;
}

export default function SurfaceProcess(props: ISurfaceProcess) {
  const colStyle = 'col-12 col-sm-6 col-md-4';
  const low = props.ActualValue?.EURange?.Low ? props.ActualValue?.EURange?.Low : 0;
  const high = props.ActualValue?.EURange?.High ? props.ActualValue?.EURange?.High : 0;
  const amout = props.ActualValue?.value ? props.ActualValue?.value : 0;
  const hasActualValue =
    props.ActualValue?.EURange?.Low !== undefined &&
    props.ActualValue?.EURange?.High !== undefined &&
    props.ActualValue?.value !== undefined;
  return (
    <div className="section surface-process">
      <div className="row">
        <SurfaceParameterTypes list={props['<Process>']} />
        <SurfaceParameterTypes list={props.MaterialA} />
        <SurfaceParameterTypes list={props.MaterialB} />
        {hasActualValue && (
          <SectionData cols={colStyle} label={labels.actualValue}>
            <Gauge min={low} max={high} amount={amout} showedValue={ShowedValue.Absolute} />
          </SectionData>
        )}
        {props.SetPointValue !== undefined && (
          <SectionData cols={colStyle} label={labels.setPoint} value={props.SetPointValue?.value} />
        )}
      </div>
    </div>
  );
}
